module.exports = __webpack_public_path__ + "static/media/dbf.f18cf4e5.svg";